<template>
    <BuilderLite v-model="model" :host="host" />
</template>

<script setup lang="ts">
import BuilderLite from '@src/Common/Builder/BuilderLite.vue';
import { createContentLiteHost } from '@src/Content/Pages/BuilderV2/contentHost';
import type { BlockNode } from '@src/Common/Builder/types';

/**
 * Content wrapper of Canvas-lite: the builder field inside a foreign form.
 * The host form owns the data via v-model; the Content lite host renders
 * with the 'field' context and no working copy.
 */
const model = defineModel<BlockNode[]>({ default: () => [] });

const host = createContentLiteHost();
</script>
